import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shift-details',
  templateUrl: './shift-details.component.html',
  styleUrls: ['./shift-details.component.css']
})
export class ShiftDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
